export default class CustomFieldTemplate {

  constructor() {
    this.name = ''
    this.template_type = ''
    this.company_id = ''
    this.custom_fields = []
  }
}
